import Vue from 'vue'
import validate from 'mixins/validate'
import passwordsCheck from 'mixins/passwords-check'

Vue.component('account-register-form', {
  data () {
    return {
    }
  },
  mixins: [validate, passwordsCheck],
  methods: {
    submitForm (e) {
      let isValid = this.validateAndDisplayErrors(e)
      const confirmPassword = this.$refs.confirmPassword

      if (!this.checkPasswords) {
        isValid = false
        confirmPassword.isValid = false
      }

      // Phone picker integration — validate + normalize to E.164 before submit
      const phone = this.$refs.phone
      if (phone && typeof phone.normalizeBeforeSubmit === 'function') {
        const phoneValid = phone.normalizeBeforeSubmit()
        if (!phoneValid) isValid = false
      }

      if (!isValid) {
        e.preventDefault()
      }
    }
  }
})
